<template>
  <div class="overflow-hidden" ref="panelContents">
    <transition name="slide" v-on:after-enter="automaticGrantFocus()">
      <BasePanel
        v-if="isShowTagSearchSuggest"
        :spaceHeight="0"
        :isOverflowYAuto="true"
        :isRoundedTop="false"
        :isShowFooter="false"
        :isShowShadow="true"
        ref="basePanel"
      >
        <template v-slot:body>
          <div class="h-full flex flex-col">
            <TextFormV2
              id="textTagFormInput"
              class="searchText mx-5 pb-4"
              inputClass="bg-gray200 !border-[0px]"
              placeholder="タグを検索"
              @input-text="onchangeText($event)"
              @click-back-button="$emit('click-back-button')"
              :maxlength="'100'"
              ref="textTagForm"
            />
            <div
              v-if="isEditing"
              class="overflow-y-auto scroll-bar-none pb-10 flex-1 mx-4"
            >
              <TagList :tags="tags" @click-tag="completeForm($event)" />
            </div>
            <!-- タグなしで検索 -->
            <div v-else-if="isScreenNearbySearch">
              <div class="flex mt-3 mx-5 mb-6">
                <div
                  class="w-full h-12 border-[1px] border-gray300 rounded-[8px]"
                  @click="resetForm()"
                >
                  <div
                    class="h-full flex justify-center items-center text-W5 text-[13px] leading-[20.8px]"
                  >
                    タグを指定せず検索
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </BasePanel>
    </transition>
  </div>
</template>
<script>
import BasePanel from '@/components/atoms/BasePanel.vue'
import TextFormV2 from '@/components/TextFormV2.vue'
import TagList from '@/components/organisms/dokoiku/TagList.vue'

const LOAD_TAG_API_SEC = 100

const TagSearchSuggest = {
  name: 'TagSearchSuggest',
  components: {
    BasePanel,
    TextFormV2,
    TagList,
  },
  emits: ['click-back-button', 'select-tag', 'click-search-spot-without-tag'],
  props: {
    // 表示フラグ
    isShowTagSearchSuggest: {
      type: Boolean,
      default: false,
    },
    isScreenNearbySearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      word: '', // 入力テキスト
      tags: [], // タグ検索候補一覧
      timer: 0, // タイマーの識別情報
      isEditing: false, // true:入力中、false:未入力
    }
  },
  watch: {
    /**
     * タグ検索画面表示状態の監視
     */
    isShowTagSearchSuggest: {
      immediate: true,
      handler(value) {
        // 表示に切り替わった時に、値を初期化し、スクロール領域の再計算を行う
        this.$nextTick(() => {
          if (value) {
            this.$refs.textTagForm.reset()
            this.word = ''
            this.isEditing = false
            this.tags = []
          }
        })
      },
    },
  },
  methods: {
    /**
     * 初回展開時のオートフォーカス付与
     */
    automaticGrantFocus() {
      this.$refs.textTagForm.focusInputForm()
    },
    /**
     * 入力文字の内容を用いてタグ検索を行う
     * @param {String} value 検索文字
     */
    onchangeText(value) {
      this.word = value
      clearTimeout(this.timer)

      //入力中かの判定
      this.isEditing = value != ''
      if (!this.isEditing) {
        // 入力文字を削除して空文字（未入力状態）にした場合、検索しない
        return
      }
      const vm = this
      this.tags = []
      const success = (tags) => (vm.tags = tags)
      // エラーで取得できなかった際は何も表示しない
      const failed = () => (vm.tags = [])
      // エラーで取得できなかった際は何も表示しない + 汎用エラー
      const error = (e) => {
        vm.tags = []
        throw e
      }
      this.timer = setTimeout(() => {
        vm.$store.dispatch('DokoikuStore/searchTagSuggestion', {
          success: success,
          failed: failed,
          error: error,
          word: vm.word,
        })
      }, LOAD_TAG_API_SEC)
    },
    /**
     * 選択されたタグ情報を送る
     * @param {Object} selectedTag 選択したタグ情報
     */
    async completeForm(selectedTag) {
      // 周辺検索処理においてキーボードが表示されている間、
      // Mapの表示領域が変わることで正しい座標が取得できないため、
      // 暫定処置としてキーボードが閉じるまで待ち時間を入れる
      // * Mapの挙動についてはNaviTimeに確認中
      const waitTime = 200
      await this.$refs.textTagForm.blurInputForm(waitTime)
      this.$emit('select-tag', selectedTag)
    },
    /**
     * タグリセットの情報を送る
     */
    async resetForm() {
      // 周辺検索処理においてキーボードが表示されている間、
      // Mapの表示領域が変わることで正しい座標が取得できないため、
      // 暫定処置としてキーボードが閉じるまで待ち時間を入れる
      // * Mapの挙動についてはNaviTimeに確認中
      const waitTime = 200
      await this.$refs.textTagForm.blurInputForm(waitTime)
      this.$emit('click-search-spot-without-tag')
    },
  },
}
export default TagSearchSuggest
</script>
<style scoped>
/* パネル昇降のトランジション */
.slide-enter-active,
.slide-leave-active {
  transform: translate(0px, 0px) translateZ(1px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(100vh) translateY(0px) translateZ(1px);
}
</style>
